/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Page, Tabs, Card, Banner, Link } from '@shopify/polaris';
import ThinkificLogo from 'src/components/ThinkificLogo';
import { Router, useNavigate, useLocation } from '@reach/router';
import styleConstants from 'src/styles/constants';
import SigninComponent from 'src/components/SignIn';
import SingupComponent from 'src/components/SignUp';
import BannerMessages from 'src/components/BannerMessages';
import { useTenantContext } from 'src/components/TenantProvider';
import ShopOwnerQuery from 'src/queries/ShopOwnerQuery';
import { useQuery } from '@apollo/react-hooks';

const tabs = [
  {
    id: 'signin',
    content: 'Sign up for Thinkific',
    path: '/auth/signup',
  },
  {
    id: 'signup',
    content: 'Connect existing site',
    path: '/auth/signin',
  },
];

const AuthComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, setErrors] = useState(null);
  const { queryParams, onSignIn } = useTenantContext();

  const { data } = useQuery(ShopOwnerQuery, {
    variables: {
      queryParams: JSON.stringify(queryParams),
    },
    fetchPolicy: 'network-only',
  });

  const shopOwnerData = data && data.shop ? data.shop.owner : {};

  const isSelected = () => {
    const path = tabs
      .map((t, index) => {
        return {
          path: t.path,
          index,
        };
      })
      .find((t) => t.path === location.pathname);
    return path ? path.index : 0;
  };

  const onTabChange = (index) => {
    const { path } = tabs[index];
    setErrors(null);
    navigate(path);
  };

  const onError = (error) => {
    setErrors(error);
  };

  const onSuccess = async (session, tenant) => {
    onSignIn(session, tenant);
  };

  const flags = useFlags();

  return (
    <Page singleColumn>
      <ThinkificLogo />
      {errors && (
        <BannerMessages message={errors.message} title={errors.title} />
      )}

      {flags.featureDowntimeBanner && (
        <Banner status="warning">
          <p>
            This service is currently unavailable due to some routine
            maintenance we’re performing to improve our systems.{' '}
            <Link
              url="https://status.thinkific.com/incidents/wqc25rly4tbl"
              external
            >
              Learn more
            </Link>
          </p>
        </Banner>
      )}

      <Card>
        <Tabs selected={isSelected()} tabs={tabs} fitted onSelect={onTabChange}>
          <Router>
            <SigninComponent
              path="/signin"
              shop={queryParams.shop}
              siteOwner={shopOwnerData}
              onError={onError}
              onSuccess={onSuccess}
            />
            <SingupComponent
              path="/signup"
              shop={queryParams.shop}
              siteOwner={shopOwnerData}
              onError={onError}
              onSuccess={onSuccess}
            />
          </Router>
        </Tabs>
      </Card>
      <style jsx>{`
        :global(.Polaris-Page) {
          padding-top: ${styleConstants.spacing.six};
        }
        :global(.Polaris-Tabs--fitted .Polaris-Tabs__Title) {
          padding: ${styleConstants.spacing.four} 0;
        }
        :global(.Polaris-Banner) {
          margin-bottom: ${styleConstants.spacing.four};
        }
      `}</style>
    </Page>
  );
};

export default AuthComponent;
